module.exports = __webpack_public_path__ + "img/tpc-web-5.78b68e0d.webp";